import styled from '@emotion/styled';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { Button } from 'src/domains/layouts/webview/components/common/button/Button';
import { Link } from 'src/domains/layouts/webview/components/router/NewLink';
import { withConfig } from 'src/withConfig';

export const OverlayDefault = withConfig(theme => styled('div', { label: 'OverlayDefault' })`
    align-items: flex-start;
    background: ${theme.star.utilityPage.bgColor};
    color: ${theme.star.utilityPage.txtColor};
    display: flex;
    inset: 0;
    justify-content: center;
    overflow-y: auto;
    padding: 24px;
    position: fixed;
    scrollbar-color: ${theme.star.scrollbar.dark.bgColor} transparent;
    scrollbar-width: thin;
    z-index: ${theme.star.zIndexGlobal.highLevel};
    ::-webkit-scrollbar {
        width: 8cqmax;
    }
    ::-webkit-scrollbar-track {
        background: transparent;
    }
    @media ${theme.star.mediaQuery.tablet} {
        padding: 16px;
    }
`);

export const Content = styled('div', { label: 'Content' })`
    margin: auto;
    max-width: 480px;
    position: relative;
    text-align: center;
    width: 100%;
`;

export const PopupHeader = withConfig(theme => styled('h2', { label: 'PopupHeader' })`
    font-size: ${theme.star.fontSize.xMedium};
    font-weight: ${theme.star.fontWeight.bold};
    line-height: 1.4;
    margin: 24px 0 0 0;
    @media ${theme.star.mediaQuery.tablet} {
        font-size: ${theme.star.fontSize.medium};
        line-height: 1.3334;
    }
`);

export const MarkedTxt = withConfig(theme => styled('a', { label: 'MarkedTxt' })`
    color: ${ theme.star.utilityPage.txtColorTertiary};
    text-decoration: underline;
`);

export const ContentRingFencedFunds = styled(Content, { label: 'ContentRingFencedFunds' })`
    max-width: 420px;
`;

export const RtpWrapper = styled(Content, { label: 'RtpWrapper' })`
    text-align: left;
    margin-top: 24px;
    max-width: 420px;
`;

export const PopupDescription = withConfig(theme => styled('p', { label: 'PopupDescription' })`
    color: ${theme.star.utilityPage.txtColorTertiary};
    font-size: ${theme.star.fontSize.small};
    line-height: 1.3334;
    margin: 16px 0;
    &:first-of-type {
        margin-top: 8px;
    }
    @media ${theme.star.mediaQuery.tablet} {
        font-size: ${theme.star.fontSize.xRegular};
        line-height: 1.4286;
    }
`);

interface TermsBoxPropsType {
    systemPagesVariant: DefaultComponentVariantType | null;
}

export const TermsBox = withConfig(theme => styled('div', { label: 'TermsBox' })<TermsBoxPropsType>`
    background: ${theme.star.utilityPage.bgColorSecondary};
    color: ${theme.star.utilityPage.txtColorTertiary};
    font-size: ${theme.star.fontSize.small};
    height: 184px;
    line-height: 1.3334;
    margin: 16px 0;
    padding: 0 4px 0 0;
    position: relative;
    border-radius: ${({ systemPagesVariant }): string => systemPagesVariant === DefaultComponentVariantType.SECONDARY ? theme.star.radius.small : '0'};
    @media ${theme.star.mediaQuery.tablet} {
        font-size: ${theme.star.fontSize.xRegular};
        line-height: 1.4286;
    }
    > div {
        hyphens: auto;
        overflow-y: auto;
        overscroll-behavior: contain;
        scrollbar-color: ${theme.star.buttons.primary.bgColorSecondary} transparent;
        scrollbar-width: thin;
        text-align: justify;
        ::-webkit-scrollbar {
            width: 4px;
        }
        ::-webkit-scrollbar-track {
            background: transparent;
        }
        ::-webkit-scrollbar-thumb {
            background: ${theme.star.buttons.primary.bgColorSecondary};
        }
    }
    > p {
        line-height: 1.3334;
    }
`);

export const AcceptBtn = withConfig(theme => styled(Button, { label: 'AcceptBtn' })`
    margin-bottom: 4px;
    width: 100%;
    @media ${theme.star.mediaQuery.tablet} {
        margin-top: 8px;
    }
`);

export const AcceptBtnContact = styled(Button, { label: 'AcceptBtnContact' })`
    width: 100%;
    margin-top: 10px;
`;

export const LinkWrapper = withConfig(theme => styled(Link, { label: 'LinkWrapper' })`
    color: ${theme.star.blockingPopUp.txtColor};
    cursor: pointer;
    font-weight: ${theme.star.fontWeight.bold};
    text-decoration: none;
    position: relative;
    &::after {
        background: currentcolor;
        content: '';
        height: 1px;
        left: 0;
        opacity: 0;
        position: absolute;
        right: 0;
        top: 100%;
        transition: opacity 0.2s ease;
    }
    &:hover {
        &::after {
            opacity: 1;
        }
    }
`);


export const TermsBoxStaticPageContent = withConfig(theme => styled('div', { label: 'TermsBoxStaticPageContent' })`
    background: ${theme.star.utilityPage.bgColorSecondary};
    color: ${theme.star.utilityPage.txtColorTertiary};
    font-size: ${theme.star.fontSize.small};
    height: 60dvh;
    line-height: 1.3334;
    margin: 16px 0;
    padding: 0 4px 0 0;
    position: relative;
    @media ${theme.star.mediaQuery.tablet} {
        font-size: ${theme.star.fontSize.xRegular};
        line-height: 1.4286;
    }
    > div {
        hyphens: auto;
        overflow-y: auto;
        overscroll-behavior: contain;
        scrollbar-color: ${theme.star.buttons.primary.bgColorSecondary} transparent;
        scrollbar-width: thin;
        text-align: justify;
        ::-webkit-scrollbar {
            width: 4px;
        }
        ::-webkit-scrollbar-track {
            background: transparent;
        }
        ::-webkit-scrollbar-thumb {
            background: ${theme.star.buttons.primary.bgColorSecondary};
        }
    }
    > p {
        line-height: 1.3334;
    }
`
);
